import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import { MobileAuthProvider } from './contexts/MobileAuthContext.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <MobileAuthProvider>
        <App />
      </MobileAuthProvider>
    </BrowserRouter>
  </React.StrictMode>
)
